// Rótulos de status do acordo e da parcela no Portal do Consumidor (extraído de
// PortalConsumidorParcelamentos.tsx para poder rodar em `node --test`, puro):
//   node --experimental-strip-types --test views/PortalConsumidor/__tests__/statusParcela.test.ts

export interface BadgeStatus {
    classe: string;
    rotulo: string;
}

export const statusAcordoBadge = (status: string): BadgeStatus => {
    if (status === 'concluido') return { classe: 'bg-green-100 text-green-700', rotulo: 'Concluído' };
    if (status === 'cancelado') return { classe: 'bg-gray-100 text-gray-500', rotulo: 'Cancelado' };
    return { classe: 'bg-amber-100 text-amber-700', rotulo: 'Ativo' };
};

/**
 * Rótulos na linguagem do consumidor: 'provisionado' = a parcela já foi embutida no
 * boleto do mês (fluxo interno de cálculo), mas ainda não foi paga.
 *
 * `hoje` é injetável só para teste — em produção é sempre `new Date()` (América/São
 * Paulo), do jeito que a tela chama.
 */
export const statusParcelaBadge = (status: string, vencimento?: string | null, hoje: Date = new Date()): BadgeStatus => {
    if (status === 'pago') return { classe: 'bg-green-100 text-green-700', rotulo: 'Paga' };
    if (status === 'provisionado') return { classe: 'bg-secondary/10 text-secondary', rotulo: 'Na fatura do mês' };
    if (status === 'cancelado') return { classe: 'bg-gray-100 text-gray-500', rotulo: 'Cancelada' };
    // Pendente com vencimento passado: "A vencer" escondia o atraso do cliente.
    const hojeStr = hoje.toLocaleDateString('sv-SE', { timeZone: 'America/Sao_Paulo' });
    if (vencimento && vencimento.slice(0, 10) < hojeStr) return { classe: 'bg-red-100 text-red-700', rotulo: 'Vencida' };
    return { classe: 'bg-amber-100 text-amber-700', rotulo: 'A vencer' };
};
